import { render, staticRenderFns } from "./PeriodScore.vue?vue&type=template&id=5bd66e77&scoped=true&"
import script from "./PeriodScore.vue?vue&type=script&lang=js&"
export * from "./PeriodScore.vue?vue&type=script&lang=js&"
import style0 from "./PeriodScore.vue?vue&type=style&index=0&id=5bd66e77&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd66e77",
  null
  
)

export default component.exports